import React from "react";
import DesktopHeader from "./desktop_header";
import MobileHeader from "./mobile_header";

const Header = () => {
  return (
    <>
      <DesktopHeader />
      <MobileHeader />
    </>
  );
};

export default Header;
